import React, { useState } from "react";
import FormWrapper from "../../components/Timesheet/FormWrapper";
import TimeSheetShift from "../../components/Timesheet/TimeSheetShift";
import history from "../../routes/history";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { configTimeSheetInit } from "../../redux/actions";

const TimeSheetStartShift = () => {
  const { StartOffsetMs = moment() } = useSelector(
    (state) => state.configTimeSheetReducer
  );
  const dispatch = useDispatch();

  const [selectedTime, setSelectedTime] = useState(
    moment(StartOffsetMs)
  );

  const handleNext = () => {
     const utcOffsetMs = moment.utc(selectedTime).valueOf(); 
    dispatch(configTimeSheetInit({ StartOffsetMs:utcOffsetMs}));
    history.push("/end-shift");
  };

  const handleTimeChange = (e) => {
    setSelectedTime(e);
  };
  
  return (
    <FormWrapper
      pageTitle={"Configure Timesheet"}
      percent={80}
      nextFunction={handleNext}
      backFunction={() => history.goBack()}
    >
      <TimeSheetShift
        label="Start shift time"
        {...{ selectedTime: moment(selectedTime, "HH:mm A"), handleTimeChange }}
      />
    </FormWrapper>
  );
};

export default TimeSheetStartShift;
